
import React, { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type AuthButtonProps = {
  type?: "button" | "submit";
  onClick?: () => void;
  loading?: boolean;
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
  disabled?: boolean; // Add the disabled prop
};

const AuthButton = ({
  type = "button",
  onClick,
  loading = false,
  children,
  icon,
  className,
  disabled = false, // Add default value
}: AuthButtonProps) => {
  return (
    <Button
      type={type}
      variant="monoDark"
      onClick={onClick}
      disabled={loading || disabled} // Update disabled logic to include both loading and disabled
      className={cn(
        "w-full relative overflow-hidden transition-all duration-200 rounded-full", 
        loading && "bg-mono-outerSpace disabled:opacity-100", // Apply hover background and override disabled opacity
        className
      )}
    >
      {loading ? (
        "Processing..."
      ) : (
        <span className="flex items-center justify-center gap-2">
          {icon}
          {children}
        </span>
      )}
    </Button>
  );
};

export default AuthButton;
